import { z } from 'my-zod'

const worldCountry = z.object({
  countryCode: z.string().min(1, 'Required'),
  countryName: z.string().min(1, 'Required')
})

const worldSubdivision = z.object({
  countryCode: z.string().min(1, 'Required'),
  subdivisionCode: z.string().min(1, 'Required').nullable(),
  subdivisionName: z.string().min(1, 'Required'),
  subdivisionType: z.string().min(1, 'Required').nullable()
})

const worldLocation = z.object({
  countryCode: z.string().min(1, 'Required'),
  locationCode: z.string().min(1, 'Required'),
  name: z.string().min(1, 'Required'),
  subdivisionCode: z.string().min(1, 'Required').nullable()
})

export const WorldLocationSchemas = {
  worldCountry,
  worldSubdivision,
  worldLocation
}

export declare namespace WorldLocationSchemas {
  export type worldCountry = z.infer<typeof worldCountry>
  export type worldSubdivision = z.infer<typeof worldSubdivision>
  export type worldLocation = z.infer<typeof worldLocation>
}
